import { Server } from "@wajeez/wajeez.microservices";
import { ContentPage, ContentPageRefType } from "@modules/content/types";

import { HomePage } from "./HomePage";
import { WajeezCastPage } from "./WajeezCastPage";
import { ContentDetailsPage } from "../details/ContentDetailsPage";
import { SkillDetailsPage } from "../skill/SkillDetailsPage";
import { PodcastDetailsPage } from "../podcast/PodcastDetailsPage";
import { PodcastHubDetailsPage } from "../podcastHub/PodcastHubDetailsPage";
import { FullBookDetailsPage } from "../fullBook/FullBookDetailsPage";
import { RamadanPage } from "../ramadan/RamadanPage";
import { LiveTheAyahDetailsPage } from "../ramadan/LiveTheAyahDetailsPage";
import { QuranDetailsPage } from "../ramadan/QuranDetailsPage";
import { PrayersDetailsPage } from "../ramadan/PrayersDetailsPage";
import { MovieDetailsPage } from "../movie/MovieDetailsPage";

export const pages: ContentPage[] = [
  HomePage,
  WajeezCastPage,
  ContentDetailsPage,
  SkillDetailsPage,
  PodcastDetailsPage,
  PodcastHubDetailsPage,
  FullBookDetailsPage,
  RamadanPage,
  LiveTheAyahDetailsPage,
  QuranDetailsPage,
  PrayersDetailsPage,
  MovieDetailsPage,
  // CategoryDetailsPage,
  // CategoryDetailsV2Page,
  // HomeFilteredPage,
];

// setAllowedPageTypes(pages.map(f => f.identifier));

export type ContentPageSelectorProps = {
  identifier: string;
  pageId: string;
  onPageLoading?: (
    pageData: Server.CollectionComponentDetailsOutput | undefined,
    isLoading: boolean
  ) => void;
  // page: Server.CollectionComponentDetailsOutput;
  context?: Server.ContentEntityOutput | undefined;
  onItemPress?: (item: Server.ContentEntityOutput) => void | Promise<void>;
  pageRef?: React.Ref<ContentPageRefType>;
};

const ContentPageSelector = (
  props: ContentPageSelectorProps
  // ref = null
) => {
  const element = pages.find((c) => c.identifier === props.identifier);

  if (!element) {
    console.log("ContentPageSelector", "element not found", props.identifier);
    return null;
  }

  return <element.page {...props} ref={props.pageRef} />;
};

export default ContentPageSelector;
